import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { useNavigation } from "@react-navigation/native";
import HomeScreen from "../screens/HomeScreen";
import ProblemOfTheDay from "../screens/ProblemOfTheDayScreen";
import SuggestedProblemScreen from "../screens/SuggestedProblemScreen";
import ProblemSearchScreenGio from "../screens/ProblemSearchScreenGio";
import ProblemSearchScreenMax from "../screens/ProblemSearchScreenMax";
import MateMATTIciScreen from "../screens/MateMATTIciScreen";
import DrawerStackNavigator from "./DrawerStackNavigator";
import ProblemById from "../screens/ProblemById";
import ProblemByDifficultyAndTopic from "../screens/ProblemByDifficultyAndTopic";

// import DrawerStackNavigator from "./DrawerStackNavigator";

const HomeStack = createNativeStackNavigator();

const HomeStackNavigator = () => {
	const navigation = useNavigation();
	return (
		<HomeStack.Navigator
			screenOptions={{
				headerShown: true,
			}}
		>
			<HomeStack.Screen
				name="Tabs"
				component={DrawerStackNavigator}
				// options={{ orientation: "all" }}
			/>
			{/* <HomeStack.Screen
				name="DrawerStack"
				component={DrawerStackNavigator}
			/> */}
			<HomeStack.Screen
				name="Home"
				component={HomeScreen}
				options={{ title: "mateMATTIci" }}
				// options={{ orientation: "all" }}
			/>
			<HomeStack.Screen
				name="ProblemOfTheDay"
				component={ProblemOfTheDay}
				options={{ title: "Problema del giorno" }}
			/>
			<HomeStack.Screen
				name="SuggestedProblem"
				component={SuggestedProblemScreen}
				options={{ title: "Problema consigliato" }}
			/>
			<HomeStack.Screen
				name="ProblemSearch"
				component={ProblemSearchScreenGio}
				options={{ title: "Ricerca problema" }}
			/>
			<HomeStack.Screen
				name="MateMATTIci"
				component={MateMATTIciScreen}
				options={{ title: "YouTube - mateMATTIci" }}
			/>
			<HomeStack.Screen
				name="ProblemById"
				component={ProblemById}
				options={{ title: "Cronologia" }}
			/>
			<HomeStack.Screen
				name="ProblemByDifficultyAndTopic"
				component={ProblemByDifficultyAndTopic}
				options={{ title: "Ricerca problema" }}
			/>
		</HomeStack.Navigator>
	);
};

export default HomeStackNavigator;
